<template>
  <ybl-select-tree ref="stree" v-model="form.cusOrgId" :showCheckbox="showCheckbox" :items="originOrganization"
    :props="treeDefaultProps" :configValue="configValue" :checkedChild="checkedChild"
    :placeholder="$attrs.placeholder || '请选择组织机构'" :clearable="!$attrs.unclearable && !$attrs.disabled" @clear="treeClear" @change="selectedChange"
    :filterDelete="filterDelete" :readonly="$attrs.disabled" :disableList='disableList' v-bind="$attrs">
  </ybl-select-tree>
</template>

<script>
export default {
  name: 'yblOrganization',
  model: {
    prop: 'item',
    event: 'change'
  },
  props: {
    item: {
      type: String | Number | Array,
      default: () => ''
    },
    showCheckbox: {
      type: Boolean,
      default: () => false
    },
    filterDelete: { // 筛选是否显示已删除的机构
      type: Boolean,
      default: () => true
    },
    configValue: { // 已选择配置的组织机构值（主要应用于非车政策）
      type: Array | String,
      default: () => []
    },
    checkedChild: { // 是否选中子机构
      type: Boolean,
      default: () => false
    },
    disableList: { // 禁用数据
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      originOrganization: [],
      treeDefaultProps: {
        children: 'Childrens',
        label: 'Label',
        id: 'Value',
        status: 'Status',
        parentId: 'ParentId',
        cancelText: '已注销', // 取消文本（显示在节点上）
        cancelField: 'Logout',
        cancelValue: 'true' // 8 注销状态 Logout=true
      },
      form: {
        cusOrgId: ''
      }
    }
  },
  created () {
    // this.getOrganization()
    console.log(this.item)
    console.log(this.configValue)
    this.form.cusOrgId = Array.isArray(this.item) ? this.item : `${this.item}`
  },
  methods: {
    getOrganization () {
      let params = {
        CityCode: null, // 所属市
        DistrictCode: null, // 所属区
        OrganizationName: null, // 机构名称
        OrganizationType: null, // 0业务类型
        PolicyLevel: null, // 0政策级别
        ProvinceCode: null // 所属省
      }
      return this.$store.dispatch('customerGetOrganization', params).then(data => {
        this.originOrganization = data.datas
        return data
      })
    },
    treeClear (item) {
      this.$refs[`stree`].resetChecked()
    },
    selectedChange (e, items) {
      // console.log('=======item=', this.form.cusOrgId)
      this.$emit('change', this.form.cusOrgId, items)
    }
  },
  watch: {
    'item': function (newVal, oldVal) {
      console.log(this.item)
      this.form.cusOrgId = this.item
      // if (!Array.isArray(this.item)) {
      //   this.form.cusOrgId = `${this.item}`
      //   console.log(this.form.cusOrgId)
      // } else {
      //   this.treeClear()
      // }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Organization.vue